
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[categoryName]",
      function () {
        return require("private-next-pages/[categoryName]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[categoryName]"])
      });
    }
  